import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Title from '../../../components/Title/index.js';
import Button from '../../../components/Button/index.js';
import Table from '../../../components/Table/index.js';
import { formatCapitalizeWord } from '../../../Helpers/Functions/index.js';
import useAdminTools from '../../../Hooks/useAdminTools.js';
import RenderString from '../../../components/RenderString/index.js';
import Loading from '../../../components/Loading/index.js';
import { useNav } from '../../../Context/Navigation';
import { getDataAPI } from '../../../Helpers/FetchAPI';
import {EyeIcon, PencilIcon} from "@heroicons/react/24/solid";
import {TrashIcon} from "@heroicons/react/24/outline";

const ToolsV2 = () => {
  const { toolsData, handleDeleteTool, isLoading } = useAdminTools();
  const [selectedTool, setSelectedTool] = useState(null);
  const [workbooks, setWorkbooks] = useState([]);
  const { t } = useTranslation();
  const { setCurrentPage } = useNav();

  useEffect(() => {
    setCurrentPage(t('Tools V2'));
  }, [setCurrentPage, t]);

  // Fetch workbooks list to map IDs to titles
  useEffect(() => {
    getDataAPI('/workbook/v2/list')
      .then((res) => {
        setWorkbooks(res.data || []);
      })
      .catch((err) => {
        console.error('Error fetching workbooks:', err);
      });
  }, []);

  const columns = useMemo(() => {
    const getCol = toolsData.map(
      ({ title, description, type, status, button }) => {
        return {  title, description, type, noOfItems: 0, status, button };
      }
    );

    const newColumns = Array.from(
      getCol.reduce((acc, obj) => {
        Object.keys(obj).forEach((key) => acc.add(key));
        return acc;
      }, new Set())
    );

    return newColumns.map((column) => {
      return {
        id: column,
        label: column === 'button' ? '' : formatCapitalizeWord(column.replace(/([A-Z])/g, ' $1')),
        align: 'center',
        fontSize: '1.6rem',
        fontWeight: '400'
      };
    });
  }, [toolsData]);

  const rows = useMemo(() => {

    return toolsData.map(
      ({ _id, title, description, type,items , status}) => {

        return {
            title:<span className="text-2xl">{title}</span>,
          description: <RenderString content={description} className=" text-center overflow-hidden text-2xl wrap-break-word " />,
          type: <span className="text-2xl">{formatCapitalizeWord(type)}</span>,
            noOfItems: <span className="text-2xl">{items?.length || 0}</span>,
            status: <span className="text-2xl">{status}</span>,
          button: (
            <div className="flex gap-2 justify-center items-center">
              <a className="hover:bg-gray-200 p-2 rounded-xl transition-colors" href={`/tools/v2/${_id}`}><div >
                  <PencilIcon className="text-pdteal size-8 cursor-pointer"/>
              </div></a>
                <div className="hover:bg-gray-200 p-2 rounded-xl transition-colors">
                    <TrashIcon className="text-pdred size-8 cursor-pointer" onClick={() => handleDeleteTool(_id)}/>
                </div>
            </div>
          )
        };
      }
    );
  }, [toolsData, handleDeleteTool, workbooks]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="w-full flex flex-col gap-8 p-8">
      <div className="flex justify-between items-center gap-8">
        <Title>Tools Management</Title>
        <Button link="/tools/v2/create" className="whitespace-nowrap">
          Create Tool
        </Button>
      </div>
      <div className="w-full bg-white rounded-lg p-8 shadow-sm">
        {toolsData.length ? (
          <Table rows={rows} columns={columns} />
        ) : (
          <div className="flex flex-col items-center justify-center py-16 px-8 text-center gap-8">
            <p className="text-lg text-gray-600">No tools created yet</p>
            <Button link="/tools/v2/create">Create Your First Tool</Button>
          </div>
        )}
      </div>

    </div>
  );
};

export default ToolsV2;
